export default __webpack_public_path__ + "static/about03-b0462d895d5886514119fa2d721cb5c1.png";